import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { ResponseData } from "../types/base"

const getData = async (): Promise<ResponseData> => {
  const { data } = await api.get<ResponseData>(`/live`)
  return data
}

export const useLive = (): QueryObserverBaseResult<ResponseData> => {
  const { data, ...props } = useQuery<ResponseData>(
    queryKeys.LIVE,
    () => getData(),
  )
  return { data, ...props }
}
